import { ToggleIconButton as CommonToggleIconButton, type ToggleIconButtonProps } from '@monorepo/common';

function ToggleIconButton(props: Omit<ToggleIconButtonProps, 'variant'>) {
  return <CommonToggleIconButton {...props} />;
}

export default ToggleIconButton;
